import React from 'react'

const WorkerCookiesPolicy = () => {
    return (
        <div>
            <div className="bg-[#F0FDF8] py-10 md:py-16 px-4">
                <div className="container mx-auto max-w-4xl">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center leading-tight">
                        Cookies & Tracking Technologies Policy
                    </h1>
                </div>
            </div>

            <div className="flex-grow container mx-auto pb-10 md:pb-16 px-4 sm:px-6">
                <div className="bg-white p-5 sm:p-8 md:p-12 max-w-4xl mx-auto">
                    <div>
                        <>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Welcome to Maidly. This Cookie & Tracking Policy is designed to be transparent about how we use digital technologies to enhance your experience across our website and mobile application. We understand that your privacy is paramount, especially when inviting service providers into your home. Therefore, we want to ensure you clearly understand how we use cookies, Software Development Kits (SDKs), and other tracking tools to make our platform work efficiently and securely. Tracking data is retained only as long as necessary for operational, legal, tax, and security purposes. We process tracking data based on your consent and/or for legitimate business purposes such as fraud prevention, security, and service delivery.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly uses cookies and similar tracking technologies to improve the experience of workers using our mobile application.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    This Cookies Policy explains how and why these technologies are used.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>1. What Are Cookies?</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Think of these technologies as a "digital memory" for the Maidly platform. They allow us to recognize your device and remember your settings so you don't have to start from scratch every time you open the app.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>1.1 The Three Main Technologies We Use:</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Cookies (Web-based):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Small text files placed on your computer or smartphone by your web browser.<br />
                                        <em>Example:</em> Remember that you’ve already seen our "New User Discount" pop-up so we don’t show it to you every five minutes.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>SDKs (App-based):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Short for "Software Development Kits," these are blocks of code inside the Maidly App that function like cookies for mobile.<br />
                                        <em>Example:</em> The Google Maps SDK helps us show you exactly where your cleaner is on the map.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Pixels and Web Beacons:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Tiny, invisible images embedded in our website or emails.<br />
                                        <em>Example:</em> These tell us if a "Booking Confirmed" email was successfully delivered and opened, ensuring you stay informed about your service.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>1.2 Why We Need Them:</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Authentication:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To keep you logged in as you move from the "Home" screen to the "Payment" screen.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Security:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To detect and prevent fraudulent bookings or unauthorized account access.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Localization:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To ensure the app shows you cleaners available in your specific city rather than somewhere else.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Preferences:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To remember your specific cleaning instructions (e.g., "The key is under the mat") for your next booking.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>1.3 First-Party vs. Third-Party:</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>First-Party:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These are placed directly by Maidly. We use these for core features like your shopping cart and account settings.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Third-Party:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These are placed by our trusted partners (like Stripe for payments or Firebase for app stability). They help us provide specialized services that make the app safer and faster.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>


                            <p><strong>2. How Maidly Uses Cookies &amp; Tracking Technologies</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We categorize our use of tracking technologies into four main pillars. Each serves a specific purpose in making your cleaning experience safer and more convenient.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>2.1 Essential &amp; Security (Non-Negotiable)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>These technologies are strictly necessary for the app to function. Without them, you cannot use our services.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Session Management:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Keeps you logged into your account so you don't have to re-authenticate every time you switch screens.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Payment Safety:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Our payment processors (like Stripe or Razorpay) use tracking to detect "bot" behavior and prevent credit card fraud.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Booking Integrity:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Ensures that the service you selected in your "cart" remains linked to your account through the checkout process.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2.2 Navigation &amp; Location (The "Live" Experience)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Because Maidly involves a physical service, location tracking is a core part of our technology.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Geofencing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Uses SDKs to notify you when your Service Provider is within 1km of your home.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Address Accuracy:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Helps auto-fill your cleaning address using GPS so that Maids don't get lost trying to find your door.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Real-Time Tracking:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Allows you to see the "live" movement of your assigned cleaner on the in-app map.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2.3 Personalization &amp; Preferences</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>These tools help us remember who you are and how you like your home cleaned.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Service History:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Remember your favorite cleaners so you can re-book them with one tap.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Instruction Storage:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Saves your specific notes (e.g., "Beware of the dog" or "Use the side entrance") so you don't have to type them every time.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Language &amp; Currency:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Automatically displays the app in your local language and currency.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2.4 Performance &amp; Reliability</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We use "Analytical" tracking to make sure the app doesn't crash when you need it most.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Error Reporting:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the app freezes, these tools send us a "crash report" so our developers can fix the bug instantly.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Load Balancing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Helps our servers handle high traffic during busy holiday cleaning seasons.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Feature Testing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Allows us to show a small group of users a new feature (like "Express Booking") to see if it works well before releasing it to everyone.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3. Types of Cookies We Use</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We classify our cookies and tracking technologies in two ways: by how long they last and who provides them.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>3.1 Based on Duration (The "Life Span")</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Session Cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These are temporary and expire the moment you close the Maidly app or your web browser.<br />
                                        <em>Purpose:</em> We use these to remember what you’ve added to your "cleaning cart" during a single visit. Once you close the app, the "session" ends and the cookie is deleted.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Persistent Cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These stay on your device for a set period or until you manually delete them.<br />
                                        <em>Purpose:</em> These are what keep you logged in so you don't have to enter your phone number and OTP every single time you want to book a maid.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3.2 Based on Source (The "Who")</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>First-Party Cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These are set directly by Maidly.<br />
                                        <em>Purpose:</em> These are essential for the "core" experience—saving your address, remembering your favorite cleaner, and managing your account security.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Third-Party Cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These are placed by our trusted partners and service providers.<br />
                                        <em>Purpose:</em> We use these for specialized functions that we don't build ourselves.<br />
                                        <em>Key Partners:</em> Payment Providers-Razorpay, Mapping Services-Google Maps, Analytics- Google Analytics.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4. Third-Party Services</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly integrates with several third-party service providers to ensure your bookings are secure, your payments are seamless, and your cleaner finds your home. These third parties may use their own cookies or SDKs to collect information directly from your device.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>4.1 Payment Processing</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>To keep your financial data safe, Maidly does not store your credit card or bank details on our own servers.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Partners:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Razorpay</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>How it works:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}When you pay, these partners use tracking technologies to verify the transaction, prevent "card-cloning" fraud, and ensure the payment is authorized by the real account holder.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.2 Maps and Geolocation</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>The core of our service is physical logistics. We use third-party mapping software to bridge the gap between you and your Service Provider.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Partner:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Google Maps API</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>How it works:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Google Maps uses identifiers to calculate the most efficient route for the Maid and to provide you with real-time "ETA" (Estimated Time of Arrival) updates. By using Maidly, you also agree to the Google Privacy Policy.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.3 Infrastructure and Stability</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We use cloud-based tools to ensure the app doesn't crash during busy periods (like holiday seasons).</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Partner:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Firebase (Google)</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>How it works:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Firebase tracks "events" within the app—such as a button not responding or a screen failing to load. This allows our engineers to fix technical issues before they affect other users.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.4 Communication &amp; Notifications</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>To keep you updated on your booking status, we use third-party communication platforms.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Partners:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Twilio for SMS for Push Notifications</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>How it works:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These services use tokens to ensure that when we send a "Your Maid is arriving" message, it goes to your specific device and nowhere else.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.5 Marketing and Growth</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We occasionally work with social media and advertising partners to show you relevant Maidly promotions.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Partners:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Google Ads</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>How it works:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These partners use pixels to see if you downloaded the app after clicking an ad. This helps us spend our marketing budget wisely so we can keep our service prices competitive.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5. Worker Control &amp; Choices</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>As a Service Provider (Maid) on the Maidly platform, tracking technologies are essential for the fulfillment of your contract, ensuring safety, and calculating your earnings. However, we provide you with controls over how and when this data is collected.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>5.1 Location Tracking &amp; "Duty" Status</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>To ensure the Maidly ecosystem functions correctly, we use GPS tracking to match you with nearby jobs and to show customers your progress.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>On-Duty Tracking:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}When you set your status to "Active" or "On-Duty," the app will use high-accuracy GPS tracking. This is essential for calculating travel time and verifying that you have arrived at the job site. By enabling "On-Duty" mode, you provide explicit consent for real-time GPS tracking during active service hours.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Off-Duty Privacy:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Once you set your status to "Inactive" or "Offline," Maidly stops active location tracking. We respect your personal time and do not track your movements when you are not working.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Your Choice:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You can toggle your "On-Duty" status at any time within the App. Note that disabling location permissions in your phone settings while "On-Duty" will prevent you from accepting new jobs.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5.2 Performance Analytics</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We use tracking to help you improve your service and earn more.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Rating &amp; Reliability:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The app tracks "On-Time" arrivals and job completion rates. This data is used to award "Top Rated" badges, which help you get more bookings.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>App Performance:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We track how the app performs on your specific device to ensure it isn't draining your battery unnecessarily or lagging during a job.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5.3 Communication Preferences</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly uses tokens to send you vital push notifications about new job opportunities or changes to your schedule.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Your Choice:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You can manage these notifications in your phone's Settings &gt; Notifications &gt; Maidly. However, we recommend keeping "Job Alerts" active so you don't miss earning opportunities.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5.4 Payout Tracking</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We use secure cookies and SDKs to link your completed jobs to your digital wallet.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Security:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These trackers ensure that your earnings are sent only to your verified bank account and protect your wallet from unauthorized access.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5.5 Managing Your Data</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Workers have the right to request a summary of the data we have collected regarding their performance and location history.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Account Deactivation:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you choose to stop working with Maidly, you can request the deletion of your account. Upon deactivation, we will stop all active tracking, though some data may be retained for legal and tax record-keeping purposes.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>


                            <p><strong>6. Changes to This Policy</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We may update this Cookie &amp; Tracking Policy from time to time to reflect changes in our technology, legal requirements, or service offerings.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>6.1 Right to Update</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly reserves the right to modify this policy at any time. Any changes will be effective immediately upon the posting of the revised policy on our website and within the Maidly App.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>6.2 How We Will Notify You</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If we make significant changes to the way we use cookies or tracking technologies (specifically regarding your privacy or location data), we will notify you through one or more of the following:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>In-App Notification:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A pop-up or banner the next time you open the Maidly App.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Email:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A message sent to the email address associated with your account.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Date Revision:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Updating the "Last Updated" date at the top of this policy.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>6.3 Your Continued Use</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Your continued use of the Maidly platform after such changes have been posted constitutes your formal acceptance of the new policy. We encourage you to review this page periodically to stay informed about how we are protecting your data and improving your experience.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>6.4 Historical Versions</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>In the event of a major legal dispute, Maidly maintains an archive of previous versions of this policy. You may request to see an older version if it pertains to a specific time frame of your usage.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>7. Your Cookie Choices &amp; Controls</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>You have control over how cookies and tracking technologies are used:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Browser Controls (Website Users):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Most web browsers allow you to block or delete cookies through browser settings. However, disabling essential cookies may affect the functionality of the Maidly website.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Mobile Device Permissions (App Users):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You may manage location access, push notifications, and certain tracking permissions through your device settings.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Marketing &amp; Analytics:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Where required by law, we request your consent before enabling non-essential tracking technologies. You may withdraw your consent at any time by adjusting your preferences within the App or contacting us at support@redqubes.com.</span>
                                </li>
                            </ul>
                            <p>
                                <span style={{ fontWeight: 400 }}>Please note that essential cookies required for security, authentication, and booking functionality cannot be disabled while using the platform.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>8. Contact Us</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We believe in open communication. If you have questions about this Cookies policy, your data rights, or how we handle your home’s security, please use the specific channels below to ensure your inquiry reaches the right department.</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>For questions regarding how we use your data, requests for data access, or updates to your personal information:</span>
                            </p>
                            <p>
                                <strong>Email:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}support@redqubes.com</span>
                            </p>
                            <p>
                                <strong>Phone:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}+91 92576 52266</span>
                            </p>
                            <p>
                                <strong>Response Time:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}We aim to respond to all privacy-related inquiries within 24–48 hours.</span>
                            </p>

                        </>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WorkerCookiesPolicy